import { createContext } from 'react'

const connectContext = createContext()

export default connectContext
